import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 80px auto;
  padding: 20px;
  width: 500px;
`;

export const Image = styled.img`
  align-self: center;
  display: block;
  margin-top: 50px;
  width: 300px;
`;

export const Title = styled(TextLayoutComponent)`
  font-size: 24px;
  font-weight: 500;
`;

export const Message = styled(TextLayoutComponent)`
  font-size: 18px;
`;

export const ContainerMessage = styled.div`
  color: #8A94AA;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  width: 100%;
`;
